class GeolocationService {
  constructor($window, $q, $rootScope) {
    // Dependencies
    this.$window = $window;
    this.$q = $q;
    this.$rootScope = $rootScope;

    this.defaultLocation = {
      latitude: 29.7604,
      longitude: -95.3698
    };
  }
  getLocation(opts) {
    var deferred = this.$q.defer();
    if (this.$window.navigator && this.$window.navigator.geolocation) {
      this.$window.navigator.geolocation.getCurrentPosition(position => {
        this.$rootScope.$apply(() => {
          deferred.resolve(position.coords);
        });
      }, (error) => {
        this.$rootScope.$apply(() => {
          deferred.reject(this.defaultLocation);
        });
      }, opts);
    } else {
      this.$rootScope.$apply(() => {
        deferred.reject(this.defaultLocation);
      });
    }
    return deferred.promise;
  }
}

GeolocationService.$inject = ['$window', '$q', '$rootScope'];

export default GeolocationService;



// WEBPACK FOOTER //
// ./src/services/geolocation.service.js